import { useHistory } from "react-router";
import { useRootDispatch, useRootSelector } from "./reduxHooks";
import { useEffect, useState } from "react";
import { logoutAction } from "store/user/user.actions";
import { getReadings } from "spectral-core/api";
import { setReadingsAction } from "store/readings/readings.actions";
import axios from "axios";

export function useGetReadings() {
  const dispatch = useRootDispatch();
  const history = useHistory();
  const [isFetching, setIsFetching] = useState(false);

  const accessToken = useRootSelector(
    (state) => state.user.currentToken?.accessToken
  );
  const readings = useRootSelector((state) => state.reading.readings);
  const lastFetchedAtTimestamp = useRootSelector(
    (state) => state.reading.lastFetchedAtTimestamp
  );

  const accessLevel = useRootSelector(
    (state) => state.user.currentUser?.accessLevel
  );

  useEffect(() => {
    async function fetchReadingsAndDispatch() {
      setIsFetching(true);
      try {
        let fromDate: Date | undefined;
        let fetchedAt: number;
        if (lastFetchedAtTimestamp !== undefined) {
          fromDate = new Date();
          fromDate.setTime(lastFetchedAtTimestamp);
          fetchedAt = fromDate.getTime();
        } else {
          // Primeira carga: últimos 18 meses (cobre safra inteira).
          fromDate = new Date();
          fromDate.setMonth(fromDate.getMonth() - 18);
          fetchedAt = Date.now();
        }
        // Dispatch progressivo a cada página para a UI refletir o crescimento
        // em tempo real e não perder dados se a paginação do backend quebrar.
        const apiReadings = await getReadings(
          accessToken!,
          accessLevel,
          fromDate,
          undefined,
          (readingsSoFar) => {
            dispatch(
              setReadingsAction({
                readings: readingsSoFar,
                fetchedAtTimestamp: fetchedAt,
              })
            );
          }
        );
        dispatch(
          setReadingsAction({
            readings: apiReadings,
            fetchedAtTimestamp: fetchedAt,
          })
        );
      } catch (err) {
        if (
          axios.isAxiosError(err) &&
          (err.response?.status === 401 || err.response?.status === 403)
        ) {
          dispatch(logoutAction());
          history.push("/");
        }
        console.log(err);
      } finally {
        setIsFetching(false);
      }
    }

    const nowTimeStamp = Date.now();
    const nowMinusAnHourTimeStamp = nowTimeStamp - 1 * 1000 * 60 * 60;

    if (
      readings === undefined ||
      lastFetchedAtTimestamp === undefined ||
      lastFetchedAtTimestamp < nowMinusAnHourTimeStamp
    ) {
      fetchReadingsAndDispatch();
    }
  }, [dispatch, history, accessToken, readings, lastFetchedAtTimestamp]);

  return { isFetching };
}
